/* eslint-disable jsx-a11y/anchor-is-valid */
import { useActivation } from '@context/MobileOne';
import {
  ApiError,
  ButtonPrimary,
  CardMain,
  CardSupport,
  DropdownList,
  FormInputField,
  Link,
  NavigationPageTitle,
  ScrollToTop
} from '@core/index';
import Icons from '@core/Utils/Icons/Icons';
import { AppPageContentWrapper } from '@part/AppPageContentWrapper';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { appButtonType, appIcons, appIconsPath } from '@utils/globalConstant';
import { Form, Formik } from 'formik';
import { useEffect } from 'react';

export function EditLegitimation() {
  // Contexts
  const { setStep8SubStep, legitimationError, legitimationMethods, updateLegitimationMethods } =
    useActivation();

  useEffect(() => {
    updateLegitimationMethods();
  }, []);

  // const
  const headerContent = tA11y('ek_reg_change_legi_hdl1');

  // Function
  const onBackClick = () => {
    setStep8SubStep(0);
  };

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper>
            <div className="mnp-activation w-100">
              <button
                type="button"
                className="border-0 bg-transparent m-0 p-0 mb-32"
                aria-label={tA11y('ek_global_icn-back_aria').ariaLabel}
                onClick={onBackClick}>
                  <Icons name="ARROW_BACK" height={24} colorType='dark'/>
              </button>

              {headerContent?.content !== '' && headerContent?.content !== undefined && (
                <>
                  {headerContent?.isHtml ? (
                    <h2
                      className="ek-h2 text-primary mb-40"
                      dangerouslySetInnerHTML={{ __html: headerContent?.content }}
                    />
                  ) : (
                    <h2 className="ek-h2 text-primary mb-40">{headerContent?.content}</h2>
                  )}
                </>
              )}
              {legitimationMethods?.length ? (
                <div className="legitimation-method-container pb-8">
                  {legitimationMethods.map((legitimation) => (
                    <div className="mb-40" key={legitimation.id}>
                      <CardMain
                        cardId={legitimation.id}
                        isRecomended={legitimation.isRecomended}
                        chip="ek_global_recommended_chip"
                        headline={tA11y(legitimation.headline)}
                        imageSource={legitimation.imageSource}
                        description={tA11y(legitimation.description)}
                        buttonProps={legitimation.buttonProps}
                        description2={tA11y(legitimation.description2)}
                        secondaryButtonProps={legitimation.secondaryButtonProps}
                      />
                    </div>
                  ))}
                </div>
              ) : null}
              {legitimationError && (
                <div className="pb-40">
                  <ApiError message={legitimationError} />
                </div>
              )}
              <CardSupport />
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default EditLegitimation;
